import React from 'react'
import {Icon} from '@chakra-ui/react'

const HistoryIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 12H2C2 17.5227 6.47728 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47728 17.5227 2 12 2C8.66708 2 5.58527 3.93769 3.49153 7H8V9H0V1H2V5.64198C4.43869 2.20287 8.02938 0 12 0C18.6273 0 24 5.37272 24 12C24 18.6273 18.6273 24 12 24C5.37272 24 0 18.6273 0 12ZM13 12.5858L16.7071 16.2929L15.2929 17.7071L11 13.4142V6H13V12.5858Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default HistoryIcon
